import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import JsonLD from "@/components/feature/JsonLD";
import HeroBanner from "./components/HeroBanner";
import FeaturedAnime from "./components/FeaturedAnime";
import PopularCategories from "./components/PopularCategories";
import LatestUpdates from "./components/LatestUpdates";
import FAQ from "./components/FAQ";
import { useEffect } from "react";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "奶水动漫在线",
  "url": "https://naishuidongman.com",
  "description": "免费高清动漫在线观看平台，提供海量动漫资源，涵盖热门番剧、经典动漫、最新连载",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://naishuidongman.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "奶水动漫在线",
  "url": "https://naishuidongman.com",
  "description": "中国领先的免费高清动漫在线观看平台，为动漫爱好者提供海量优质动漫资源。",
  "email": "contact@naishuidongman.com",
  "foundingDate": "2020",
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "奶水动漫在线需要注册才能观看吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "不需要！奶水动漫在线完全免费开放，您无需注册或登录即可畅享所有动漫资源。",
      },
    },
    {
      "@type": "Question",
      "name": "动漫的画质如何？支持哪些清晰度？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "我们提供高清（720P）和超清（1080P）两种画质选择。所有动漫资源均经过精心压制，确保在保证清晰度的同时优化加载速度。",
      },
    },
    {
      "@type": "Question",
      "name": "支持手机和平板观看吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "当然支持！奶水动漫在线采用响应式设计，完美适配电脑、平板和手机等各类设备。",
      },
    },
    {
      "@type": "Question",
      "name": "动漫更新频率是怎样的？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "我们会与日本同步更新热门连载番剧，通常在播出后24小时内完成中文字幕制作并上架。",
      },
    },
    {
      "@type": "Question",
      "name": "如何找到我想看的动漫？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以通过顶部的搜索功能直接搜索动漫名称，也可以通过分类页面按「热血」「恋爱」「搞笑」「奇幻」等类型浏览。",
      },
    },
    {
      "@type": "Question",
      "name": "奶水动漫在线的动漫资源是否正版？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "我们尊重知识产权，所有动漫资源均来自公开渠道。我们建议用户支持正版。",
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLD data={websiteSchema} />
      <JsonLD data={organizationSchema} />
      <JsonLD data={faqPageSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <FeaturedAnime />
          <PopularCategories />
          <LatestUpdates />
          <FAQ />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}